module.exports = __webpack_public_path__ + "static/media/group-18.41e3f02f.svg";